export * from './baMsgCenter.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baMsgCenter/index.ts